module.exports = __webpack_public_path__ + "img/video-a4.28f1daaa.jpg";